export default "__VITE_ASSET__CKWrv_k3__"